import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

/** Una opción del menú. `confirmar` (texto) la vuelve destructiva en dos toques: el primero cambia
 *  el renglón a ese texto en rojo, el segundo la ejecuta. `tip` es la explicación, en tooltip. */
export interface OpcionMenu {
  clave: string;
  texto: string;
  icono?: string;       // clase de Font Awesome, p. ej. 'fa-external-link-alt'
  tip?: string;
  peligro?: boolean;
  confirmar?: string;
  separar?: boolean;    // una línea antes de esta opción
}

/**
 * El menú de tres puntos (dropdown-menu del registro de shadcn, con las clases del Gateway calcadas
 * en `.kb-menu*` de styles.css). Juan, 2026-10-08: «pon tres puntos donde, si le das clic, puedes
 * liberar»; «quitar este archivo… eso tiene que quedar en un tooltip». Lo que borra o suelta se
 * confirma DENTRO del menú, sin modal y sin texto al lado de los botones.
 */
@Component({
  selector: 'app-kb-menu',
  template: `
    <span class="kb-menu-ancla">
      <button type="button" class="kb-btn kb-btn-outline kb-btn-icon" [class.kb-btn-sm]="chico"
              [attr.aria-label]="etiqueta" [title]="etiqueta" aria-haspopup="menu" [attr.aria-expanded]="abierto"
              [disabled]="deshabilitado" (click)="alternar($event)">
        <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
      </button>
      <div class="kb-menu" role="menu" *ngIf="abierto" (click)="$event.stopPropagation()">
        <ng-container *ngFor="let o of opciones">
          <div class="kb-menu-sep" *ngIf="o.separar" role="separator"></div>
          <button type="button" role="menuitem" class="kb-menu-item"
                  [class.kb-menu-peligro]="o.peligro && confirmando !== o.clave"
                  [class.kb-menu-confirmar]="confirmando === o.clave"
                  [attr.data-kb-tip]="confirmando === o.clave ? null : (o.tip || null)"
                  (click)="elegirOpcion(o)">
            <i class="fas" [ngClass]="o.icono" *ngIf="o.icono && confirmando !== o.clave" aria-hidden="true"></i>
            {{ confirmando === o.clave ? o.confirmar : o.texto }}
          </button>
        </ng-container>
      </div>
    </span>`,
})
export class KbMenuComponent {
  @Input() opciones: OpcionMenu[] = [];
  @Input() etiqueta = 'Más acciones';
  @Input() chico = false;
  @Input() deshabilitado = false;
  @Output() elegir = new EventEmitter<string>();

  abierto = false;
  confirmando: string | null = null;

  constructor(private el: ElementRef) { }

  alternar(ev: Event): void {
    ev.stopPropagation();
    this.abierto = !this.abierto;
    this.confirmando = null;
  }

  elegirOpcion(o: OpcionMenu): void {
    if (o.confirmar && this.confirmando !== o.clave) { this.confirmando = o.clave; return; }
    this.cerrar();
    this.elegir.emit(o.clave);
  }

  cerrar(): void { this.abierto = false; this.confirmando = null; }

  @HostListener('document:click', ['$event'])
  fuera(ev: Event): void { if (this.abierto && !this.el.nativeElement.contains(ev.target)) this.cerrar(); }

  @HostListener('document:keydown.escape')
  escape(): void { if (this.abierto) this.cerrar(); }
}
